import React from 'react';

import { Button } from '@interlayer/js/components/common/Button';

import { componentService } from '@core/js/services/component.service';
import { useAppSelector } from '@core/js/store/hooks/useAppSelector';

import { useAutoGameLaunch } from '@interlayer/js/app/components/main/Games/hooks/useGameLaunch';

import { TButtonLaunchGameProps } from './types';

export const ButtonLaunchGame: React.FC<TButtonLaunchGameProps> = ({ gamecode, children, ...props }) => {
    const game = useAppSelector((state) => state.gamesConfiguration?.[gamecode]);
    const launchGame = useAutoGameLaunch(game);

    return (
        <Button
            onClick={launchGame}
            {...props}
        >
            {children}
        </Button>
    );
};

componentService.registerWebContentComponents({ ButtonLaunchGame });
